<template>
  <div class="container-fluid mt-2">
    <h2>PDF Kataloge</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <input @keyup="updateSearch()" placeholder="Suche" type="text" class="form-control" v-model="searchValue"/>
      </div>
      <button id="new" @click="addItem()" class="btn btn-primary">Hinzuf&uuml;gen</button>
    </div>
    <b-table no-local-sorting @sort-changed="updateSort" class="mt-3" striped hover :fields="fields" :items="rows">
      <template v-slot:cell(action)="data">
        <button @click="renameItem(data.item)" class="btn btn-secondary"><font-awesome-icon icon="edit"/></button>
        <button @click="deleteItem(data.item)" class="btn btn-danger ml-1"><font-awesome-icon icon="trash"/></button>
      </template>
    </b-table>
    <p class="text-muted"><font-awesome-icon icon="question-circle"/> Verlinkung von Artikeln direkt im iHand: http://[YOURURL]?mapid=100024</p>
    <b-modal id="editPDFDoc" size="lg" title="PDF Dokument">
      <div class="form-group">
        <label>Name:</label><input class="form-control" id="catname" type="text">
      </div>
      <div class="form-group">
        <label>PDF-Datei:</label><input class="form-control" id="catfile" type="file">
      </div>
      <template v-slot:modal-footer="{}">
        <p align="right">
          <button id="save" @click="saveDoc" class="btn btn-primary">Speichern</button>&nbsp;<button @click="cancel" id="cancel" class="btn btn-secondary">Abbrechen</button>
        </p>
      </template>
    </b-modal>
    <b-modal id="delPDFDoc" title="Achtung!" header-bg-variant="danger" @ok="deleteAccepted">
      <p>Möchten Sie wirklich den Katalog <strong>({{ delid }}) {{ delname }}</strong> löschen?</p>
    </b-modal>
    <b-modal id="renamePDFDoc" title="Katalog bearbeiten" @ok="renameSubmit">
      <div class="form-group">
        <label>Name des Katalogs</label>
        <input v-model="editItem.name" type="form-control"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import catalogs from '@/modules/catalogs.js'

export default {
  name: 'PDFCatalogs',
  data() {
    return {
      fields: [
        { key: 'id', label: 'ID', sortable: true},
        { key: 'name', label: 'Name', sortable: true},
        { key: 'path', label: 'Dateipfad', sortable: true},
        { key: 'date', label: 'Erstellt' },
        { key: 'action', label: 'Aktion' },
      ],
      rows: [],
      delid:-1,
      delname: '',
      searchValue: '',
      editItem: {}
    }
  },
  mounted: function() {
    this.fetchData();
  },
  methods: {
    addItem: function() {
      this.$bvModal.show('editPDFDoc');
    },
    updateSearch() {
      catalogs.viewparams.search = this.searchValue;
      this.fetchData();
    },
    updateSort(data) {
      var sort = data.sortBy;
      catalogs.viewparams.sdir = (data.sortDesc ? 'desc' : 'asc');
      catalogs.viewparams.sort = sort;
      this.fetchData();
    },
    fetchData: function() {
      var self = this;
      catalogs.list(this,function(data) {
        self.rows = data;
      })
    },
    cancel: function() {
      this.$bvModal.hide('editPDFDoc');
    },
    saveDoc: function() {
      var self = this;
      var file = document.getElementById('catfile');
      var name = document.getElementById('catname').value;
      catalogs.save(this,name,file,function() {
        self.$bvToast.toast('Katalog gespeichert.',{title: 'PDF Kataloge', variant:"success"});
        self.fetchData();
      });
      this.$bvModal.hide('editPDFDoc');
    },
    deleteItem: function(item) {
      console.log(item.id + ' ' + item.name);
      this.delid = item.id;
      this.delname = item.name;
      this.$bvModal.show('delPDFDoc');
    },
    renameItem(item) {
      console.log('rename',item);
      this.editItem = JSON.parse(JSON.stringify(item));
      this.$bvModal.show('renamePDFDoc');
    },
    renameSubmit() {
      console.log(this.editItem);
      var self = this;
      fetch(config.baseUrl + 'rest/catalogs/rename/' + encodeURIComponent(this.editItem.id) + '?name=' + encodeURIComponent(this.editItem.name)).then(function(resp) {
        if (resp.status != 200) {
          resp.text().then(function(err) {
            self.$bvToast.toast('Fehler bei Aktualisierung: ' + JSON.stringify(err),{variant:'danger',title:'Fehler'});
          });
        } else {
          self.$bvToast.toast('Katalog aktualisiert.',{variant:'success',title:'Kataloge'});
          self.fetchData();
        }
      }).catch(function(err) {
        self.$bvToast.toast('Fehler bei Aktualisierung: ' + JSON.stringify(err),{variant:'danger',title:'Fehler'});
      });
    },
    deleteAccepted: function() {
      if (this.delid) {
        var self = this;
        catalogs.delete(this,this.delid,function() {
          self.$bvToast.toast('Katalog gelöscht.',{title: 'PDF Kataloge', variant:"success"});
          self.fetchData();
        });
      }
    },
    prevPage: function() {
      if (catalogs.viewparams.page > 1) {
        catalogs.viewparams.page--;
        this.fetchData();
      }
    },
    nextPage: function() {
      if (this.rows.length > 0) {
        catalogs.viewparams.page++;
        this.fetchData();
      }
    },
  }
}
</script>
